import React from "react";
import "./Resource.scss";

const Resource = () => {
  return <div>Resource</div>;
};

export default Resource;
